import React from 'react';
import './App.css';
import Summary from './components/Summary';
import About from './components/About';
import Experience from './components/Experience';
import Projects from './components/Projects';
import GitHub from './components/GitHub';
import Skills from './components/Skills';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <main>
        <Summary />
        <Experience />
        <Projects />
        <GitHub />
        <Skills />
        <About />
      </main>
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
